<template>
  <div>
    <div class="row my-4 align-items-center">
      <div class="col-lg-8">
        <div class="row">
          <div class="col-lg-6">
            <vue-select
              name="periodo"
              v-model="periodo"
              class="select-periodo"
              :clearable="false"
              :options="optionsPeriodo"
              label="label"
              placeholder="Período"
              @input="onChangePeriodo"
            >
              <template slot="option" slot-scope="option">
                {{ option.label }}
              </template>
              <div slot="no-options">Não há opções correspondentes</div>
            </vue-select>
          </div>
          <div class="col-lg-6">
            <vue-select
              id="select-tipo-equipe"
              name="tipo-equipe"
              v-model="tipoEquipe"
              class="select-tipo-equipe"
              :clearable="true"
              :options="optionsTipoEquipe"
              label="label"
              placeholder="Todas"
              @input="onChangeTipoEquipe"
            >
              <template slot="option" slot-scope="option">
                {{ option.label }}
              </template>
              <div slot="no-options">Não há opções correspondentes</div>
            </vue-select>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <download-files
          :callback-pdf="generatePdf"
          :data="dadosExportacao"
          :fields="dataFieldsPercentual"
          name="resultado-municipal-ranking"
          class="float-right"
        >
        </download-files>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="resultado-filtros">
          <ResultadoToggle v-model="tipoResultado" />

          <FiltroPrevistoRealizado
            v-if="exibirFiltroPrevistoRealizado"
            v-model="filtroResultadoQuadrimestral"
          />
        </div>
      </div>
    </div>
    <v-app class="app-tabela">
      <div class="box" style="margin-top: 0px">
        <v-card class="tabela">
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar por CNES, UBS ou INE"
              class="input-bottom"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            @pagination="getPagination"
            :page="currentPage"
            :footer-props="{
              itemsPerPageText: '',
              'items-per-page-options': [10],
              'disable-items-per-page': true,
            }"
            :loading="loading"
            loading-text="Carregando, Por favor espere"
            :headers="headers"
            :items="dadosDaTabela"
            :item-class="getRowColor"
            :search="search"
            :single-expand="true"
            :expanded.sync="expanded"
            item-key="id"
            class="elevation-1"
            show-expand
            @item-expanded="onItemExpanded"
          >
            <!-- <template #footer.prepend>
          <v-spacer />
        </template> -->

            <template v-slot:item.nota="{ item }">
              <template v-if="isIndicadorSemPontuacao(item)">
                {{ getPlaceholderNota() }}</template
              >
              <template v-else> {{ getNotaTabela(item) }}</template>
            </template>

            <template v-slot:item.confianca="{ item }">
              <template v-if="getConfiancaPrincipal(item)">
                <span class="d-inline-flex align-items-center">
                  {{ getConfiancaPrincipal(item).valor }}
                  <i
                    :class="
                      getConfiancaPrincipal(item).isValido
                        ? 'icofont-check text-success'
                        : 'icofont-close text-danger'
                    "
                    class="ml-1 font-weight-bold"
                  ></i>
                </span>
              </template>
              <template v-else>-</template>
            </template>

            <template v-slot:item.resultado="{ item }">
              <template v-if="isIndicadorSemPontuacao(item)">
                {{ getPlaceholderPontuacao() }}</template
              >
              <template v-else>{{ getPontuacaoTabela(item) }}</template>
            </template>

            <template v-slot:item.classificacao="{ item }">
              <template v-if="isIndicadorSemPontuacao(item)">{{
                getPlaceholderClassificacao()
              }}</template>
              <template v-else>
                {{ getClassificacaoTabela(item) }}
                <span
                  v-if="!isRealizadoSelecionado()"
                  v-b-tooltip.html.hover
                  :title="getTextoClassificacaoTooltip(item)"
                  class="icon-tooltip"
                >
                  <i class="icofont-info-circle"></i>
                </span>
              </template>
            </template>

            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <table class="table table-interna">
                  <thead>
                    <tr>
                      <th>Indicador</th>
                      <th>Peso</th>
                      <th>Numerador</th>
                      <th>Denominador</th>
                      <th>Pontuação</th>
                      <th v-if="isRealizadoSelecionado()">Diferença</th>
                      <th>Nota</th>
                      <th>Classificação</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item2, index) in item.dadosIndicadores"
                      :key="index"
                    >
                      <td>
                        {{ item2.ds_indicador }}
                      </td>
                      <td>
                        {{ item2.peso }}
                      </td>
                      <td>
                        <template v-if="isRealizadoSelecionado()">-</template>
                        <template v-else-if="item2.indicador == 47">-</template>
                        <div v-else>
                          {{ getValorIndicador(item2, 'numerador') }}
                          <span
                            v-if="getValorIndicador(item2, 'numerador') !== '-'"
                            v-b-tooltip.html.hover
                            v-bind:title="
                              getTooltipsTexts(item2.indicador).numerador
                            "
                            class="icon-tooltip"
                          >
                            <i class="icofont-info-circle"></i>
                          </span>
                        </div>
                      </td>
                      <td>
                        {{
                          isRealizadoSelecionado()
                            ? '-'
                            : getValorIndicador(item2, 'denominador')
                        }}
                        <span
                          v-if="
                            !isRealizadoSelecionado() &&
                            getValorIndicador(item2, 'denominador') !== '-'
                          "
                          v-b-tooltip.html.hover
                          v-bind:title="
                            getTooltipsTexts(item2.indicador).denominador
                          "
                          class="icon-tooltip"
                        >
                          <i class="icofont-info-circle"></i>
                        </span>
                      </td>
                      <td>
                        {{
                          getValorIndicadorPrevistoRealizado(
                            item,
                            item2,
                            'resultado'
                          )
                        }}
                        <span
                          v-b-tooltip.html.hover
                          v-bind:title="
                            getTooltipsTexts(item2.indicador).resultado
                          "
                          class="icon-tooltip"
                        >
                          <i class="icofont-info-circle"></i>
                        </span>
                      </td>
                      <td v-if="isRealizadoSelecionado()">
                        <template v-if="getConfiancaExpandida(item, item2)">
                          <span class="d-inline-flex align-items-center">
                            {{ getConfiancaExpandida(item, item2).valor }}
                            <i
                              :class="
                                getConfiancaExpandida(item, item2).isValido
                                  ? 'icofont-check text-success'
                                  : 'icofont-close text-danger'
                              "
                              class="ml-1 font-weight-bold"
                            ></i>
                          </span>
                        </template>
                        <template v-else>-</template>
                      </td>
                      <td>
                        {{
                          getValorIndicadorPrevistoRealizado(
                            item,
                            item2,
                            'nota'
                          )
                        }}
                      </td>
                      <td>
                        <template v-if="!isRealizadoSelecionado()">
                          <TextoClassificacaoIndicador
                            :classificacao="
                              getValorIndicador(item2, 'classificacao')
                            "
                            :idIndicador="item2.indicador"
                            :resultado="getValorIndicador(item2, 'resultado')"
                          />
                        </template>

                        <template v-else>
                          {{
                            getValorIndicadorPrevistoRealizado(
                              item,
                              item2,
                              'classificacao'
                            )
                          }}
                        </template>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div>
                  <apexchart
                    type="line"
                    height="350"
                    :series="[]"
                    :options="chartOptions"
                    ref="chartSerieHistorica"
                  ></apexchart>
                </div>
              </td>
            </template>

            <template v-slot:[`footer.page-text`]="items">
              <div class="info-table-item tabela-esus-pec">
                <FonteSincronizadorC />
              </div>
              <span class="paginacao"
                >{{ items.pageStart }} - {{ items.pageStop }} de
                {{ items.itemsLength }} registros</span
              >
            </template>

            <template v-slot:progress>
              <v-progress-linear
                color="blue"
                :height="10"
                indeterminate
              ></v-progress-linear>
            </template>
            <template v-slot:no-data>
              <div class="alert alert-info mb-0">
                <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
              </div>
            </template>
            <template v-slot:no-results style="padding: 0px">
              <div class="alert alert-info mb-0">
                <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </div>
    </v-app>
  </div>
</template>

<script>
import * as Functions from './functions.js'
import utils from '@/mixins/utils.js'
import ShowHideField from '@/components/utils/ShowHideField.vue'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import { dataFieldsPercentual } from './utils.js'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import VueApexCharts from 'vue-apexcharts'
import TextoClassificacaoIndicador from '@/components/utils/TextoClassificacaoIndicador'
import ResultadoToggle from './components/ResultadoToggle.vue'
import FiltroPrevistoRealizado from './components/FiltroPrevistoRealizado.vue'
import Template from '../../AedesAegypti/Template.vue'

export default {
  name: 'TabelaCadastros',
  components: {
    ShowHideField,
    DownloadFiles,
    apexchart: VueApexCharts,
    TextoClassificacaoIndicador,
    ResultadoToggle,
    FiltroPrevistoRealizado,
    Template,
  },
  props: {
    cadastros: {
      type: Array,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [utils],
  data() {
    return {
      currentPage: 1,
      expanded: [],
      enabled: null,
      search: '',
      periodo: null,
      optionsPeriodo: [],
      tipoEquipe: null,
      optionsTipoEquipe: [
        { label: 'eSF', value: '70' },
        { label: 'eAP', value: '76' },
        { label: 'eSB', value: '71' },
        { label: 'eMulti', value: '72' },
      ],
      dataFieldsPercentual: {
        ...dataFieldsPercentual,
      },
      selectedCheckbox: [],
      dadosDaTabela: [],
      chartData: [],
      chartOptions: {
        chart: {
          height: 300,
          type: 'line',
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'straight',
          width: 2,
        },
        title: {
          text: 'Série Histórica',
          align: 'center',
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'],
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          min: 0,
          max: 100,
        },
        legend: {
          show: true,
          position: 'top',
          horizontalAlign: 'center',
        },
        markers: {
          size: 5,
        },
        colors: [
          '#1f77b4',
          '#ff7f0e',
          '#2ca02c',
          '#d62728',
          '#9467bd',
          '#8c564b',
          '#e377c2',
        ],
      },
      tipoResultado: 'quadrimestral',
      filtroResultadoQuadrimestral: 'previsto',
    }
  },
  watch: {
    cadastros: {
      handler(newValue, oldValue) {
        this.currentPage = 1
        const periodos = Array.from(
          new Map(
            this.cadastros
              .filter((item) => item.mes_ano) // garante válido
              .map((item) => [
                item.mes_ano, // chave única
                {
                  mes_ano: item.mes_ano,
                  mes_ano_quad: item.mes_ano_quad,
                },
              ])
          ).values()
        )
        // ordenação desc
        periodos.sort((a, b) => {
          const [mesA, anoA] = a.mes_ano.split('/').map(Number)
          const [mesB, anoB] = b.mes_ano.split('/').map(Number)

          if (anoA !== anoB) return anoB - anoA
          return mesB - mesA
        })

        // monta options do select
        this.optionsPeriodo = periodos.map((p) => {
          const mes = Number(p.mes_ano.split('/')[0])
          const isQuad = [4, 8, 12].includes(mes)

          return {
            value: p.mes_ano,
            label: isQuad && p.mes_ano_quad ? p.mes_ano_quad : p.mes_ano,
          }
        })
        this.periodo = this.optionsPeriodo[0]
        this.setTipoEquipe()
        this.filterData(this.periodo, this.tipoEquipe)
      },
      deep: true,
    },
    search: {
      handler(newValue) {
        if (newValue) {
          this.$emit('filterSearch', { filter: this.filterItems(newValue) })
          return
        }
        this.$emit('filterSearch', { filter: false })
      },
      deep: true,
    },

    tipoResultado() {
      if (!this.exibirFiltroPrevistoRealizado) {
        this.filtroResultadoQuadrimestral = 'previsto'
      }

      this.filterData(this.periodo, this.tipoEquipe)

      if (this.expanded.length) {
        this.onItemExpanded({ item: this.expanded[0] })
      }
    },

    filtroResultadoQuadrimestral(valor) {
      const filtro = valor || 'previsto'

      if (valor !== filtro) {
        this.filtroResultadoQuadrimestral = filtro
      }

      this.filterData(this.periodo, this.tipoEquipe)

      if (this.expanded.length) {
        this.onItemExpanded({ item: this.expanded[0] })
      }
    },

    periodo() {
      if (!this.exibirFiltroPrevistoRealizado) {
        this.filtroResultadoQuadrimestral = 'previsto'
      }
    },
  },
  computed: {
    headers() {
      const baseHeaders = [
        {
          text: 'N°',
          align: 'start',
          sortable: false,
          filterable: false,
          value: 'colocacao',
        },
        {
          text: 'CNES',
          align: 'start',
          filterable: true,
          value: 'nu_cnes',
          width: '130px',
        },
        {
          text: 'UBS',
          align: 'start',
          filterable: true,
          value: 'no_unidade_saude',
        },
        {
          text: 'INE',
          align: 'start',
          filterable: true,
          value: 'nu_ine',
        },
        {
          text: 'Equipe',
          align: 'start',
          filterable: true,
          value: 'no_equipe',
        },
        {
          text: 'Nota',
          align: 'start',
          sortable: false,
          filterable: false,
          value: 'nota',
        },
      ]

      if (this.isRealizadoSelecionado()) {
        baseHeaders.push({
          text: 'Diferença',
          align: 'start',
          sortable: false,
          filterable: false,
          value: 'confianca',
        })
      }

      baseHeaders.push(
        {
          text: 'Pontuação',
          align: 'start',
          sortable: false,
          filterable: false,
          value: 'resultado',
        },
        {
          text: 'Classificação',
          align: 'start',
          sortable: false,
          filterable: false,
          value: 'classificacao',
        },
        { text: '', value: 'data-table-expand' }
      )

      return baseHeaders
    },

    dadosExportacao() {
      return this.dadosDaTabela.map((item) => {
        const indicadorSemPontuacao = this.isIndicadorSemPontuacao(item)
        const confianca = this.getConfiancaPrincipal(item)

        return {
          ...item,

          nota_previsto_exportacao: indicadorSemPontuacao
            ? this.getPlaceholderNota()
            : item.nota,

          nota_realizado_exportacao:
            indicadorSemPontuacao || !this.isRealizadoSelecionado()
              ? this.getPlaceholderNota()
              : item.dadosMs?.nota ?? '-',

          confianca_exportacao:
            indicadorSemPontuacao ||
            !this.isRealizadoSelecionado() ||
            !confianca
              ? '-'
              : confianca.valor,

          resultado_previsto_exportacao: indicadorSemPontuacao
            ? this.getPlaceholderPontuacao()
            : item.resultado,

          resultado_realizado_exportacao:
            indicadorSemPontuacao || !this.isRealizadoSelecionado()
              ? this.getPlaceholderPontuacao()
              : item.dadosMs?.resultado ?? '-',

          classificacao_previsto_exportacao: indicadorSemPontuacao
            ? this.getPlaceholderClassificacao()
            : item.classificacao ?? '-',

          classificacao_realizado_exportacao:
            indicadorSemPontuacao || !this.isRealizadoSelecionado()
              ? this.getPlaceholderClassificacao()
              : item.dadosMs?.classificacao ?? '-',
        }
      })
    },

    exibirFiltroPrevistoRealizado() {
      if (this.tipoResultado !== 'quadrimestral' || !this.periodo) {
        return false
      }

      const mes = Number(this.periodo.value.split('/')[0])

      return [4, 8, 12].includes(mes)
    },
  },
  methods: {
    /**
     * Retorna os dados de confiança da tabela principal (Nota eSUS Feedback - Nota SIAPS).
     * Se o valor for > 0.5 ou < -0.5, check vermelho.
     * Se o valor estiver entre -0.5 e 0.5, check verde.
     *
     * @param {Object} item Dados da equipe.
     * @returns {Object|null}
     */
    getConfiancaPrincipal(item) {
      if (
        this.isIndicadorSemPontuacao(item) ||
        item.dadosMs?.nota === undefined ||
        item.dadosMs?.nota === null ||
        item.dadosMs?.nota === '-' ||
        item.nota === undefined ||
        item.nota === null ||
        item.nota === '-'
      ) {
        return null
      }

      const notaEsus = Number(item.nota)
      const notaSiaps = Number(item.dadosMs.nota)

      if (isNaN(notaEsus) || isNaN(notaSiaps)) {
        return null
      }

      const diff = Number((notaEsus - notaSiaps).toFixed(2))
      const isValido = diff >= -0.5 && diff <= 0.5

      return {
        valor: diff,
        isValido,
      }
    },

    /**
     * Retorna os dados de confiança da tabela expandida (Pontuação eSUS Feedback - Pontuação SIAPS).
     * Se o valor for > 5 ou < -5, check vermelho.
     * Se o valor estiver entre -5 e 5, check verde.
     *
     * @param {Object} item Dados da equipe.
     * @param {Object} item2 Dados do indicador previsto.
     * @returns {Object|null}
     */
    getConfiancaExpandida(item, item2) {
      const pontuacaoEsusRaw = this.getValorIndicador(item2, 'resultado')
      const indicadorRealizado = this.getIndicadorRealizado(
        item,
        item2.indicador
      )

      if (!indicadorRealizado) {
        return null
      }

      const pontuacaoSiapsRaw = this.getValorIndicador(
        indicadorRealizado,
        'resultado'
      )

      if (
        pontuacaoEsusRaw === '-' ||
        pontuacaoEsusRaw === null ||
        pontuacaoEsusRaw === undefined ||
        pontuacaoSiapsRaw === '-' ||
        pontuacaoSiapsRaw === null ||
        pontuacaoSiapsRaw === undefined
      ) {
        return null
      }

      const pontuacaoEsus = Number(pontuacaoEsusRaw)
      const pontuacaoSiaps = Number(pontuacaoSiapsRaw)

      if (isNaN(pontuacaoEsus) || isNaN(pontuacaoSiaps)) {
        return null
      }

      const diff = Number((pontuacaoEsus - pontuacaoSiaps).toFixed(2))
      const isValido = diff >= -5 && diff <= 5

      return {
        valor: diff,
        isValido,
      }
    },
    /**
     * Retorna o placeholder utilizado quando a nota
     * não deve ser exibida.
     *
     * @returns {String}
     */
    getPlaceholderNota() {
      return '*.**'
    },

    /**
     * Retorna o placeholder utilizado quando a pontuação
     * não deve ser exibida.
     *
     * @returns {String}
     */
    getPlaceholderPontuacao() {
      return '***.**'
    },

    /**
     * Retorna o placeholder utilizado quando a classificação
     * não deve ser exibida.
     *
     * @returns {String}
     */
    getPlaceholderClassificacao() {
      return '*****'
    },

    /**
     * Verifica se o indicador não possui nota, pontuação e classificação
     * na visualização mensal.
     *
     * @param {Object} indicador Dados do indicador.
     * @returns {Boolean}
     */
    isIndicadorSemPontuacao(indicador) {
      return (
        this.tipoResultado === 'mensal' &&
        [57, 58, 59].includes(Number(indicador.indicador))
      )
    },

    /**
     * Retorna previsto ou previsto / realizado para a tabela interna.
     *
     * @param {Object} item Dados da equipe.
     * @param {Object} indicadorPrevisto Indicador previsto.
     * @param {String} campo Campo desejado.
     * @returns {*}
     */
    getValorIndicadorPrevistoRealizado(item, indicadorPrevisto, campo) {
      const previsto = this.getValorIndicador(indicadorPrevisto, campo)

      if (!this.isRealizadoSelecionado()) {
        return previsto
      }

      const indicadorRealizado = this.getIndicadorRealizado(
        item,
        indicadorPrevisto.indicador
      )

      const realizado = indicadorRealizado
        ? this.getValorIndicador(indicadorRealizado, campo)
        : '-'

      return `${previsto} / ${realizado}`
    },

    /**
     * Retorna a nota da tabela principal.
     * No realizado, exibe previsto / realizado.
     */
    getNotaTabela(item) {
      if (!this.isRealizadoSelecionado()) {
        return item.nota
      }

      return `${item.nota} / ${item.dadosMs?.nota ?? '-'}`
    },

    /**
     * Retorna a pontuação da tabela principal.
     * No realizado, exibe previsto / realizado.
     */
    getPontuacaoTabela(item) {
      if (!this.isRealizadoSelecionado()) {
        return item.resultado
      }

      return `${item.resultado} /  ${item.dadosMs?.resultado ?? '-'}`
    },

    /**
     * Retorna a classificação da tabela principal.
     * No realizado, exibe previsto / realizado.
     */
    getClassificacaoTabela(item) {
      if (!this.isRealizadoSelecionado()) {
        return item.classificacao ?? '-'
      }

      return `${item.classificacao ?? '-'} / ${
        item.dadosMs?.classificacao ?? '-'
      }`
    },

    /**
     * Verifica se a visualização Realizado está ativa.
     * Só retorna true quando o tipo de resultado é quadrimestral
     * e o filtro selecionado é Realizado.
     *
     * @returns {Boolean}
     */
    isRealizadoSelecionado() {
      return (
        this.tipoResultado === 'quadrimestral' &&
        this.filtroResultadoQuadrimestral === 'realizado'
      )
    },

    /**
     * Busca nos dados realizados o indicador correspondente.
     *
     * @param {Object} item Dados da equipe.
     * @param {Number|String} indicador Código do indicador.
     * @returns {Object|null}
     */
    getIndicadorRealizado(item, indicador) {
      const dadosMs = item.dadosMs

      if (!dadosMs || !Array.isArray(dadosMs.all_indicadores)) {
        return null
      }

      return (
        dadosMs.all_indicadores.find(
          (el) => Number(el.indicador) === Number(indicador)
        ) || null
      )
    },

    /**
     * Retorna o valor do campo conforme o tipo de resultado selecionado
     * para cada indicador.
     *
     * @param {Object} item Dados do indicador.
     * @param {String} campo Nome do campo (numerador, denominador, resultado, nota ou classificacao).
     * @returns {*} Valor do campo conforme o indicador e o tipo de resultado selecionado.
     */
    getValorIndicador(item, campo) {
      const indicador = Number(item.indicador)

      // Indicador 46
      if (indicador === 46) {
        if (this.tipoResultado === 'mensal') {
          return item[`${campo}_mes`] ?? '-'
        }

        return item[campo] ?? '-'
      }

      // Indicadores 51 e 52
      if ([51, 52].includes(indicador)) {
        if (this.tipoResultado === 'mensal') {
          return item[`${campo}_all`] ?? '-'
        }

        return item[campo] ?? '-'
      }

      // Indicadores 47, 48, 49, 50
      if ([47, 48, 49, 50].includes(indicador)) {
        return item[campo] ?? '-'
      }

      // Indicadores 44 e 45
      if ([44, 45].includes(indicador)) {
        if (this.tipoResultado === 'mensal') {
          return item[campo] ?? '-'
        }

        return item[`${campo}_quad`] ?? '-'
      }

      // Indicadores 38, 39, 40, 41, 42, 43
      if ([38, 39, 40, 41, 42, 43].includes(indicador)) {
        if (this.tipoResultado === 'mensal') {
          return item[campo] ?? '-'
        }

        return item[`${campo}_quad`] ?? '-'
      }

      return item[campo] ?? '-'
    },

    /**
     * Filtra os registros da tabela com base no texto de busca.
     * Considera apenas as colunas marcadas como filtráveis nos headers.
     * @param {String} search Texto digitado para pesquisa
     * @returns {Array} Lista de itens filtrados
     */
    filterItems(search) {
      const searchTerms = search.toLowerCase().trim()
      const filteredItems = this.cadastros.filter((item) => {
        for (const header of this.headers) {
          if (header.filterable && item.hasOwnProperty(header.value)) {
            const itemValue = String(item[header.value]).toLowerCase()
            if (itemValue.includes(searchTerms)) {
              return true
            }
          }
        }
        return false
      })
      return filteredItems
    },

    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    /**
     * Retorna a classe CSS da linha da tabela.
     *
     * @param {Object} item
     * @returns {String}
     */
    getRowColor(item) {
      return ``
    },

    /**
     * Define o tipo de equipe padrão conforme o perfil do usuário.
     */
    setTipoEquipe() {
      let idFuncao = this.$store.state.id_funcao

      if (idFuncao == 4 || idFuncao == 3) {
        this.tipoEquipe = { label: 'eSF', value: '70' }
        return
      }

      if (idFuncao == 8 || idFuncao == 14) {
        this.tipoEquipe = { label: 'eSB', value: '71' }
        return
      }

      if (idFuncao == 15) {
        this.tipoEquipe = { label: 'eMulti', value: '72' }
        return
      }
    },

    /**
     * Atualiza os dados da tabela ao alterar o período selecionado.
     *
     * @param {Object} periodo Período selecionado.
     */
    onChangePeriodo(periodo) {
      this.expanded = []
      this.filterData(periodo, this.tipoEquipe)
    },

    /**
     * Atualiza os dados da tabela ao alterar o tipo de equipe selecionado.
     *
     * @param {Object} tipoEquipe Tipo de equipe selecionado.
     */
    onChangeTipoEquipe(tipoEquipe) {
      this.expanded = []
      this.filterData(this.periodo, tipoEquipe)
    },

    /**
     * Atualiza os dados da tabela ao alterar um filtro adicional.
     *
     * @param {*} filtro Filtro aplicado.
     */
    onChangeFiltro(filtro) {
      this.filterData(this.periodo, this.tipoEquipe, filtro)
    },

    /**
     * Filtra os registros pelo período selecionado.
     *
     * @param {Array} data Lista de registros.
     * @returns {Array} Registros filtrados.
     */
    filterByPeriodo(data) {
      return data.filter((el) => {
        return el.mes_ano === this.periodo.value
      })
    },

    /**
     * Filtra os registros pelo tipo de equipe selecionado.
     *
     * @param {Array} data Lista de registros.
     * @param {Object} tipoEquipe Tipo de equipe selecionado.
     * @returns {Array} Registros filtrados.
     */
    filterByTipoEquipe(data, tipoEquipe) {
      const tipo = String(tipoEquipe.value)

      return data.filter((item) => {
        if (!item.dados_equipe) {
          return false
        }

        try {
          const dadosEquipe = JSON.parse(item.dados_equipe)

          return dadosEquipe?.nu_ms === tipo
        } catch (error) {
          return false
        }
      })
    },

    /**
     * Aplica os filtros selecionados e atualiza os dados exibidos na tabela.
     *
     * @param {Object|null} periodo Período selecionado.
     * @param {Object|null} tipoEquipe Tipo de equipe selecionado.
     */
    filterData(periodo, tipoEquipe) {
      let data = this.cadastros
      if (periodo != null) {
        data = this.filterByPeriodo(data)
      }
      if (tipoEquipe != null) {
        data = this.filterByTipoEquipe(data, tipoEquipe)
      }
      this.dadosDaTabela = this.mapCadastros(data)
    },

    /**
     * Mapeia os registros retornados pela API para o formato utilizado pela tabela.
     *
     * @param {Array} cadastros Lista de registros.
     * @returns {Array} Lista formatada para exibição.
     */
    mapCadastros(cadastros) {
      const dadosMapeados = cadastros.map((item) => {
        const dadosEquipe = JSON.parse(item.dados_equipe)
        const dadosIndicadores = JSON.parse(item.dados_indicadores)
        const dadosMs = this.parseObjectJson(item.dados_indicadores_ms)

        return {
          ...item,

          nu_cnes: dadosEquipe.nu_cnes,
          no_unidade_saude: dadosEquipe.no_unidade_saude,
          nu_ine: dadosEquipe.nu_ine,
          no_equipe: dadosEquipe.no_equipe,

          dadosIndicadores,

          nota: Number(item.nota) || 0,
          resultado: Number(item.resultado) || 0,
          dadosMs: dadosMs[0] || {},
        }
      })

      return dadosMapeados.map((item, index) => ({
        ...item,
        colocacao: `${index + 1}°`,
        id: index,
      }))
    },

    /**
     * Retorna o nome de um indicador a partir do seu identificador.
     *
     * @param {Number} idIndicador Identificador do indicador.
     * @returns {String} Nome do indicador.
     */
    getNomeIndicador(idIndicador) {
      const nomesIndicadores = {
        46: 'Mais acesso à APS',
        51: 'Desenvolvimento infantil',
        52: 'Gestante e puérpera',
        48: 'Pessoa com diabetes',
        50: 'Pessoa com hipertensão',
        49: 'Pessoa idosa',
        47: 'Prevenção do câncer na mulher',
        44: 'Média de atendimentos por pessoa',
        45: 'Ações interprofissionais',
        38: 'Primeira consulta programada',
        43: 'Tratamento concluído',
        39: 'Taxa de exodontias',
        42: 'Escovação supervisionada',
        40: 'Procedimentos preventivos',
        41: 'Tratamento Restaurador Atraumático',
        53: 'Gestantes',
      }
      return nomesIndicadores[idIndicador] || ''
    },

    /**
     * Retorna os textos utilizados nos tooltips de um indicador.
     *
     * @param {Number} idIndicador Identificador do indicador.
     * @returns {Object|String} Objeto contendo os textos do tooltip.
     */
    getTooltipsTexts(idIndicador) {
      const nomesIndicadores = {
        46: {
          numerador:
            'Total de atendimentos por demanda programada (consulta agendada programada; cuidado continuado; e consulta agendada).',
          denominador:
            'Total de atendimentos por todos os tipos de demandas (espontâneas e programadas).',
          resultado: 'Numerador / Denominador * 100',
          classificacao: [
            'Regular: <= 10 ou > 70',
            'Suficiente: > 10 e <= 30',
            'Bom: > 30 e <= 50',
            'Ótimo: > 50 e <= 70',
          ],
        },
        51: {
          numerador:
            'Somatório da(s) boa(s) prática(s) pontuada(s) durante o acompanhamento do desenvolvimento infantil.',
          denominador:
            'Total de crianças com idade igual a 2 (dois) anos completos.',
          resultado: 'Numerador / Denominador',
          classificacao: [
            'Regular: <= 25',
            'Suficiente: > 25 e <= 50',
            'Bom: > 50 e <= 75',
            'Ótimo: > 75 e <= 100',
          ],
        },
        52: {
          numerador:
            'Somatório da(s) boa(s) prática(s) pontuada(s) durante o acompanhamento de uma pessoa gestante e puérpera.',
          denominador:
            'Total de mulheres com encerramento de puerpera no quadrimestre avaliado.',
          resultado: 'Numerador / Denominador',
          classificacao: [
            'Regular: <= 25',
            'Suficiente: > 25 e <= 50',
            'Bom: > 50 e <= 75',
            'Ótimo: > 75 e <= 100',
          ],
        },
        48: {
          numerador:
            'Somatório da(s) boa(s) prática(s) pontuada(s) durante o acompanhamento da pessoa com diabetes.',
          denominador: 'Total de pessoas com diabetes.',
          resultado: 'Numerador / Denominador',
          classificacao: [
            'Regular: <= 25',
            'Suficiente: > 25 e <= 50',
            'Bom: > 50 e <= 75',
            'Ótimo: > 75 e <= 100',
          ],
        },
        50: {
          numerador:
            'Somatório da(s) boa(s) prática(s) pontuada(s) durante o acompanhamento da pessoa com hipertensão arterial.',
          denominador: 'Total de pessoas com hipertensão arterial.',
          resultado: 'Numerador / Denominador',
          classificacao: [
            'Regular: <= 25',
            'Suficiente: > 25 e <= 50',
            'Bom: > 50 e <= 75',
            'Ótimo: > 75 e <= 100',
          ],
        },
        49: {
          numerador:
            'Somatório da(s) boa(s) prática(s) pontuada(s) durante o acompanhamento da pessoa idosa.',
          denominador: 'Total de pessoas idosas.',
          resultado: 'Numerador / Denominador',
          classificacao: [
            'Regular: <= 25',
            'Suficiente: > 25 e <= 50',
            'Bom: > 50 e <= 75',
            'Ótimo: > 75 e <= 100',
          ],
        },
        47: {
          numerador:
            'Somatório da(s) boa(s) prática(s) aplicável(is) para a mulher.',
          denominador: 'Total de mulheres elegíveis na faixa etária.',
          resultado: 'Numerador / Denominador',
          classificacao: [
            'Regular: <= 25',
            'Suficiente: > 25 e <= 50',
            'Bom: > 50 e <= 75',
            'Ótimo: > 75 e <= 100',
          ],
        },
        44: {
          numerador:
            'Total de atendimentos individuais e coletivos realizados pela eMulti no quadrimestre avaliado.',
          denominador: 'Total de pessoas atendidas no quadrimestre avaliado.',
          resultado: 'Numerador / Denominador',
          classificacao: [
            'Regular: <= 1',
            'Suficiente: > 1 e <= 2',
            'Bom: > 2 e <= 3',
            'Ótimo: > 3',
          ],
        },
        45: {
          numerador:
            'Total de ações compartilhadas realizadas pela eMulti no quadrimestre avaliado.',
          denominador: 'Total de ações realizadas pela eMulti.',
          resultado: 'Numerador / Denominador * 100',
          classificacao: [
            'Regular: <= 1',
            'Suficiente: > 1 e <= 2,5',
            'Bom: > 2,5 e <= 5',
            'Ótimo: > 5',
          ],
        },
        38: {
          numerador:
            'Total de pessoas com atendimentos de primeira consulta odontológica programática.',
          denominador: 'Total de pessoas vinculadas à equipe.',
          resultado: 'Numerador / Denominador * 100',
          classificacao: [
            'Regular: <= 1',
            'Suficiente: > 1 e <= 3',
            'Bom: > 3 e <= 5',
            'Ótimo: > 5',
          ],
        },
        43: {
          numerador: 'Total de pessoas com tratamento odontológico concluído.',
          denominador:
            'Total de pessoas com primeira consulta odontológica programada.',
          resultado: 'Numerador / Denominador * 100',
          classificacao: [
            'Regular: <= 25',
            'Suficiente: > 25 e <= 50',
            'Bom: > 50 e <= 75',
            ' Ótimo: > 75 e <= 100',
          ],
        },
        39: {
          numerador: 'Total de exodontias.',
          denominador:
            'Total de procedimentos clínicos individuais preventivos, curativos e exodontias realizados.',
          resultado: 'Numerador / Denominador * 100',
          classificacao: [
            'Regular: < 8 ou >= 14',
            'Suficiente: >= 12 e < 14',
            'Bom: >= 10 e < 12',
            'Ótimo: >= 8 e < 10',
          ],
        },
        42: {
          numerador:
            'Total de pessoas participantes da ação coletiva de escovação dental supervisionada realizada em crianças com idade entre 6 e 12 anos.',
          denominador: 'Total de pessoas vinculadas à equipe.',
          resultado: 'Numerador / Denominador * 100',
          classificacao: [
            'Regular: <= 0,25',
            'Suficiente: > 0,25 e <= 0,5',
            'Bom: > 0,5 e <= 1',
            'Ótimo: > 1',
          ],
        },
        40: {
          numerador:
            'Total de procedimentos odontológicos individuais preventivos.',
          denominador:
            'Todos os procedimentos odontológicos individuais registrados.',
          resultado: 'Numerador / Denominador * 100',
          classificacao: [
            'Regular: < 40 ou > 85',
            'Suficiente: >= 40 e < 60',
            'Bom: >= 60 e < 80',
            'Ótimo: >= 80 e <= 85',
          ],
        },
        41: {
          numerador:
            'Total de procedimentos do tipo Tratamento Restaurador Atraumático.',
          denominador: 'Total de procedimentos restauradores.',
          resultado: 'Numerador / Denominador * 100',
          classificacao: [
            'Regular: <= 3',
            'Suficiente: > 3 e <= 6',
            'Bom: > 6 e <= 8',
            'Ótimo: > 8',
          ],
        },
        53: {
          numerador: 'Total de gestantes com atendimento odontológico.',
          denominador: 'Total de gestantes da equipe vinculada.',
          resultado: 'Numerador / Denominador * 100',
          classificacao: [],
        },
      }

      const indicador = nomesIndicadores[idIndicador]
      if (!indicador) return ''

      return {
        ...indicador,
        classificacao: indicador.classificacao.join('<br>'),
      }
    },

    /**
     * Retorna o texto do tooltip da classificação da equipe.
     *
     * @param {Object} item Dados da equipe.
     * @returns {String|null} Texto do tooltip.
     */
    getTextoClassificacaoTooltip(item) {
      const lista = this.$store.state.regrasIndicadoresAps || []

      // Se for Regular, pode ter vários registros
      const itens =
        item.classificacao === 'Regular'
          ? lista.filter(
              (i) =>
                i.id_indicador == item.indicador &&
                i.classificacao === item.classificacao
            )
          : [
              lista.find(
                (i) =>
                  i.id_indicador == item.indicador &&
                  i.classificacao === item.classificacao
              ),
            ].filter(Boolean)

      if (!itens.length) return null

      const partesParametro = itens
        .map((item) => {
          const partes = []

          if (item.sinal_min && item.min_val) {
            partes.push(`${item.sinal_min} ${item.min_val}`)
          }

          if (item.sinal_max && item.max_val) {
            partes.push(`${item.sinal_max} ${item.max_val}`)
          }

          // Se vierem os dois no mesmo registro, junta com " e "
          return partes.join(' e ')
        })
        .filter(Boolean)

      const parametro = partesParametro.join(' e ')

      const ref = itens[0]

      return `Peso: ${ref.peso} <br>
              Nota: ${item.nota} ${parametro} <br>
              Classificação: ${ref.classificacao} `
    },

    /**
     * Retorna os indicadores do cadastro conforme o filtro selecionado.
     * Previsto: usa dados_indicadores.
     * Realizado: usa dados_indicadores_ms.
     *
     * @param {Object} item Cadastro original.
     * @returns {Array}
     */
    getIndicadoresCadastroParaGrafico(item) {
      if (this.isRealizadoSelecionado()) {
        const dadosMs = this.parseObjectJson(item.dados_indicadores_ms)

        return dadosMs[0]?.all_indicadores || []
      }

      const dadosIndicadores = this.parseObjectJson(item.dados_indicadores)

      return dadosIndicadores || []
    },

    /**
     * Manipula o evento de expansão de um item da tabela.
     * @param {Object} item Contexto do item expandido
     */
    onItemExpanded(item) {
      const periodos = Array.from(
        new Set(
          this.cadastros.map((cad) => cad.mes_ano).filter((mesAno) => mesAno)
        ) // remove null, undefined e strings vazias)
      ).sort((a, b) => {
        const [mesA, anoA] = a.split('/').map(Number)
        const [mesB, anoB] = b.split('/').map(Number)

        // menor -> maior (ano, depois mês)
        if (anoA !== anoB) return anoA - anoB
        return mesA - mesB
      })

      let element = item.item

      // Indicadores únicos
      const indicadoresUnicos = element.dadosIndicadores.map((d) => ({
        indicador: d.indicador,
        nome: d.ds_indicador,
      }))

      // Monta as séries por indicador
      const series = indicadoresUnicos.map((ind) => {
        const data = periodos.map((mes_ano) => {
          const dadoDoMes = this.cadastros.find(
            (cad) =>
              cad.mes_ano === mes_ano &&
              JSON.parse(cad.dados_equipe).nu_cnes === element.nu_cnes &&
              JSON.parse(cad.dados_equipe).nu_ine === element.nu_ine
          )

          if (!dadoDoMes) return null

          const indicadoresDoMes =
            this.getIndicadoresCadastroParaGrafico(dadoDoMes)

          const indicadorEncontrado = Array.isArray(indicadoresDoMes)
            ? indicadoresDoMes.find(
                (i) => Number(i.indicador) === Number(ind.indicador)
              )
            : null

          const valor = indicadorEncontrado
            ? this.getValorIndicador(indicadorEncontrado, 'resultado')
            : null

          if (
            valor === '-' ||
            valor === null ||
            valor === undefined ||
            valor === ''
          ) {
            return null
          }

          return Number(valor)
        })

        return {
          name: this.getNomeIndicador(ind.indicador),
          data,
        }
      })

      this.$nextTick(() => {
        if (this.$refs.chartSerieHistorica) {
          this.$refs.chartSerieHistorica.updateOptions({
            xaxis: {
              categories: periodos,
            },
          })
          this.$refs.chartSerieHistorica.updateSeries(series)
        }
      })
    },

    /**
     * Gera o PDF do ranking contendo a tabela principal, a tabela interna
     * de indicadores e a série histórica.
     */
    generatePdf() {
      const title_pdf = 'Resultado Municipal - Ranking'
      const titlePdfSave = this.titlePdf('Resultado Municipal - Ranking')
      const description_pdf = 'Classificação por equipe nos Indicadores APS.'
      const headers_pdf = [
        'N°',
        'CNES',
        'UBS',
        'INE',
        'EQUIPE',
        'NOTA REALIZADA',
        'NOTA VERIFICADA',
        ...(this.isRealizadoSelecionado() ? ['DIFERENÇA'] : []),
        'PONTUAÇÃO REALIZADA',
        'PONTUAÇÃO VERIFICADA',
        'CLASSIFICAÇÃO REALIZADA',
        'CLASSIFICAÇÃO VERIFICADA',
      ]

      const doc = new jsPDF({
        orientation: 'landscape',
        ...this.encryptionPdf(),
      })

      this.fileToBase64(this.$store.state.infoMunicipio.brasao)
        .then((base64data) => {
          let verticalPosition = this.headerPdf(
            doc,
            base64data,
            title_pdf,
            description_pdf
          )

          const filterTipoEquipe =
            this.tipoEquipe != null ? this.tipoEquipe.label : ''
          verticalPosition = this.bodyPdf(
            doc,
            [
              { label: 'Período', value: this.periodo.value },
              { label: 'Equipe', value: filterTipoEquipe },
            ],
            verticalPosition
          )

          // Linhas principais + linha de detalhe (que receberá a tabela interna)
          const bodyRows = []
          this.dadosExportacao.forEach((item) => {
            bodyRows.push([
              item.colocacao,
              item.nu_cnes,
              item.no_unidade_saude,
              item.nu_ine,
              item.no_equipe,
              item.nota_previsto_exportacao,
              item.nota_realizado_exportacao,
              ...(this.isRealizadoSelecionado()
                ? [item.confianca_exportacao]
                : []),
              item.resultado_previsto_exportacao,
              item.resultado_realizado_exportacao,
              item.classificacao_previsto_exportacao,
              item.classificacao_realizado_exportacao,
            ])

            const indicadores = Array.isArray(item.dadosIndicadores)
              ? item.dadosIndicadores
              : (() => {
                  try {
                    return JSON.parse(item.dadosIndicadores || '[]')
                  } catch {
                    return []
                  }
                })()

            bodyRows.push({
              isDetail: true,
              item,
              indicadores,
              cells: [''], // 1 célula que vai ocupar a largura toda via colspan
            })
          })

          doc.autoTable({
            head: [headers_pdf],
            body: bodyRows,
            startY: verticalPosition,
            theme: 'striped',
            headStyles: {
              fillColor: '#ccc',
              fontSize: 6,
              textColor: '#000',
              halign: 'center',
              cellWidth: 'wrap',
            },
            bodyStyles: {
              fontSize: 6,
              halign: 'center',
            },
            styles: { cellPadding: 2 },

            // Faz a linha de detalhe ocupar 100% (colSpan = total de colunas)
            didParseCell: (data) => {
              const raw = data.row?.raw
              if (raw && raw.isDetail && data.section === 'body') {
                data.cell.colSpan = data.table.columns.length
                data.cell.styles.fillColor = [245, 245, 245]
                data.cell.styles.halign = 'left'
                data.cell.styles.cellPadding = {
                  top: 3,
                  right: 2,
                  bottom: 3,
                  left: 2,
                }
                data.cell.text = [''] // o conteúdo será desenhado manualmente
              }
            },

            // Desenha a TABELA INTERNA ocupando 100% da largura da célula
            didDrawCell: (data) => {
              const raw = data.row?.raw
              if (!raw || !raw.isDetail || data.section !== 'body') return

              // evita render duplicado quando a mesma linha se estende para outra página
              if (raw.__innerRendered) return
              // garante que só dispare na primeira célula da linha
              if (
                typeof data.column?.index !== 'undefined' &&
                data.column.index !== 0
              )
                return

              if (
                !Array.isArray(raw.indicadores) ||
                raw.indicadores.length === 0
              )
                return

              const docRef = data.doc
              const cell = data.cell

              const innerHead = [
                [
                  'Indicador',
                  'Peso',
                  'Numerador',
                  'Denominador',
                  'Resultado',
                  ...(this.isRealizadoSelecionado() ? ['Diferença'] : []),
                  'Nota',
                  'Classificação',
                ],
              ]

              const innerBody = raw.indicadores.map((i) => {
                const confiancaExp = this.getConfiancaExpandida(raw.item, i)

                return [
                  i?.ds_indicador ?? '',
                  i?.peso ?? '',
                  this.isRealizadoSelecionado()
                    ? '-'
                    : i?.indicador == 47
                    ? '-'
                    : this.getValorIndicador(i, 'numerador'),
                  this.isRealizadoSelecionado()
                    ? '-'
                    : this.getValorIndicador(i, 'denominador'),
                  this.getValorIndicadorPrevistoRealizado(
                    raw.item,
                    i,
                    'resultado'
                  ),
                  ...(this.isRealizadoSelecionado()
                    ? [confiancaExp ? String(confiancaExp.valor) : '-']
                    : []),
                  this.getValorIndicadorPrevistoRealizado(raw.item, i, 'nota'),
                  this.getValorIndicadorPrevistoRealizado(
                    raw.item,
                    i,
                    'classificacao'
                  ),
                ]
              })

              const paddingX = 3
              const paddingY = 3
              const startY = cell.y // gruda no topo da célula de detalhe

              // página antes
              const pageBefore = docRef.internal.getCurrentPageInfo().pageNumber
              const pageHeight = docRef.internal.pageSize.getHeight()

              docRef.autoTable({
                head: innerHead,
                body: innerBody,
                startY,
                // 100% da largura da célula
                margin: {
                  left: cell.x,
                  right:
                    docRef.internal.pageSize.getWidth() - (cell.x + cell.width),
                },
                tableWidth: cell.width,
                theme: 'grid',
                styles: {
                  fontSize: 6,
                  halign: 'center',
                  cellPadding: {
                    top: paddingY / 2,
                    bottom: paddingY / 2,
                    left: paddingX / 2,
                    right: paddingX / 2,
                  },
                },
                headStyles: {
                  fillColor: [230, 230, 230],
                  textColor: 20,
                  fontStyle: 'bold',
                },
                pageBreak: 'avoid',
              })

              const last = docRef.lastAutoTable
              const pageAfter = docRef.internal.getCurrentPageInfo().pageNumber

              if (pageAfter > pageBefore) {
                // se a subtabela foi jogada para a próxima página: limita a altura da linha atual
                const availableCurrentPage = pageHeight - cell.y - paddingY
                data.row.height = Math.max(
                  data.row.height,
                  availableCurrentPage
                )
              } else {
                // se a subtabela coube na mesma página: ajusta pela altura real
                const neededHeight = last.finalY - cell.y + paddingY
                if (neededHeight > data.row.height)
                  data.row.height = neededHeight
              }

              // marca como renderizada para esta linha de detalhe
              raw.__innerRendered = true
            },
          })

          this.footerPdfCentralizado(doc, doc.autoTable.previous.finalY, 'l')
          doc.save(titlePdfSave + '.pdf')

          this.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
            position: 'topRight',
          })
        })
        .catch((error) => {
          console.error(error)
          this.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
            position: 'topRight',
          })
        })
    },
  },
}
</script>

<style scoped lang="scss">
.resultado-filtros {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  justify-content: flex-end;
  margin-bottom: 15px;
}
</style>
